import { Optional } from 'utility-types'
import TextFilter, { ITextFilterProps } from './TextFilter'
import { KnockOperator } from '../Knock/KnockTypes'

type RegistrationFilterProps = Optional<ITextFilterProps, 'operators'>

const RegistrationFilter = (props: RegistrationFilterProps) => {
  const operators = [KnockOperator.EqualTo, KnockOperator.NotEqualTo, KnockOperator.StringWildcard, KnockOperator.StartsWith]
  return <TextFilter operators={operators} {...props} />
}

export default RegistrationFilter
